<!-- FORM FIELDS -->
<p-panel>
    <div style="display: flex; gap:10px; ">
        <h4>Datos de {{this.env.parcelaName}}</h4>
        <div *ngIf="loadingData">
            <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="6" animationDuration="1.5s">
            </p-progressSpinner>
        </div>
    </div>
    
    <div class="row">            
        <app-reactive-form-builder
                #formbuilder
                (formChanges)="formChanges($event[0], $event[1])"
                (goBack)="goBack()"
                (afterSend)="afterSend($event)"
                [form]="form.formFields"
                [serverUrl]="''"
                [dropdownLoadTrigger]="dropdownLoadTrigger"
                [previousData]="getModel()"
                [request]="this.getType() === 1 ? this.fincasApi.parcelasPUT : this.fincasApi.parcelasPOST">
        </app-reactive-form-builder>
    </div>

    <div class="row">
        <app-reactive-form-builder #formbuilder (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()"
            (afterSend)="afterSend($event)" [form]="form.formFields" [serverUrl]="''"
            [dropdownLoadTrigger]="dropdownLoadTrigger" [previousData]="getModel()"
            [request]="this.getType() === 1 ? this.fincasApi.parcelasPUT : this.fincasApi.parcelasPOST">
        </app-reactive-form-builder>
    </div>

</p-panel>
<p-dialog [header]="'Mapa ' + form.parcelaNombre" [(visible)]="form.mapaAbierto" #mapaDialog (onShow)="scrollToTop()">
                         
  <div *ngIf="form.mapaAbierto" style="height:86%; margin-left:20px; margin-right:20px; width: 80vw !important">
    <app-mapa-add
        [origin]="origin"
        [finca]="form.finca"
        [localidad]="form.localidad"
        [cultivo]="form.cultivo"
        [variedad]="form.variedad"
        [parcelaNombre]="form.parcelaNombre"
        (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
  <br>

</p-dialog>

<app-dialog-sigpac-form  #sigpac  (sendSigPac)="getSigPac($event)"></app-dialog-sigpac-form>